import { CanActivateFn, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { inject } from '@angular/core';

export const roleGuard: CanActivateFn = (route, state) => {
  const commonService = inject(CommonService);
  const router = inject(Router);

  const user = commonService.userDetails();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  if (user.role?.toLowerCase() === 'superadmin') {
    if (!state.url.startsWith('/admin')) {
      router.navigate(['/admin/dashboard']);
      return false;
    }
    return true;
  }

  const isSystemAdmin = user.role === 'admin';

  const requiredModule = route.data['module'] as string;
  if (requiredModule && isSystemAdmin) {
    const userModules = user.modules || [];
    const hasModuleAccess = userModules.some(
      (m: any) => m.name?.toLowerCase() === requiredModule.toLowerCase()
    );
    if (!hasModuleAccess) {
      router.navigate(['/dashboard']);
      return false;
    }
  }

  const allowedRoles = route.data['roles'] as string[];
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
